import { CheckedIcon } from "../_components/icons/icons";

export const setIsFetching = (state) => {
  return {
    ...state,
    isFetching: true
  }
};

export const filterCalendarResults = (state, data) => {
  let result = [];
  for(let i = 1; i <= 12; i++) {
    let checked = data.length > 0 ? data.find(obj => obj.month === i): false;
    if (checked) {
      result.push({
        month: i,
        events: checked.events ? checked.events : checked.dates
      })
    } else {
      result.push({
        month: i,
        events: []
      })
    }
  }

  return {
    ...state,
    isFetching: false,
    data: result
  };
};

export const resetCalendarResults = (state, data) => {
  return {
    ...state,
    isFetching: false,
    data: [],
    errorMessage: data
  };
};

export const filterUserFund = (data) => {
  let result = null;
  
  if (data) {
    result = {
      fundId: data.fundId,
      fundCode: data.fundCode? data.fundCode: data.thailandFundCode,
      categoryCode: data.categoryCode,
      color: data.color
    }
  }

  return  result;
};

export const generateArrayOfYears = () => {
  let max = new Date().getFullYear()
  let min = max - 9
  let years = []

  for (let i = max; i >= min; i--) {
    years.push(i)
  }
  return years
}

export const filterCalendarByDate = (state, data) => {
  let result = {
    ...state,
    isFetching: false,
    data: data.length > 0 ? data[0].events : []
  };

  return result;
}